import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button, Grid } from "@/comn/components";
import { useForm, useFetch, useStore, useToast, useModal, useResource, useGrid, usePage } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LBL_LANG_SRCH, SG_LBL_LANG_LIST } from "./services/OsciLblLangPrcssService";
import { Link } from "react-router-dom";

/**
 * Label processing List
 * !==  라벨 처리 목록 ==!
 *
 */
export const OSCI0111004Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0083" },
            { area: "comnCd", comnCd: "OSC0088" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        lblLangSrch: useForm({
            defaultSchema: SF_LBL_LANG_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        lblLangLst: useGrid({
            defaultSchema: SG_LBL_LANG_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Label processing List !==  라벨 처리 목록 조회==!
        getLblLangLst: useFetch({
            api: (page = grid.lblLangLst.page) => {
                return APIS.getLblLangList(form.lblLangSrch.getValues(), page, grid.lblLangLst.size);
            },
            enabled: comnUtils.isEmpty(form.lblLangSrch.errors) && form.lblLangSrch.isSubmitted,
            key: [grid.lblLangLst.page, grid.lblLangLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.lblLangSrch.getValues(),
                    page: grid.lblLangLst.page,
                    size: grid.lblLangLst.size,
                });
            },
        }),
        //Delete processing information !==  라벨 처리 정보 삭제 ==!
        deleteLblLang: useFetch({
            api: (lblIds) => APIS.deleteLblLang(lblIds),
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00006" });
                handler.getLblLangList();
            },
            onError: () => {},
            showToast: true,
        }),
    };
    const render = {
        cell: {
            lblId: (props: any) => {
                const { rowValues, value } = props;
                // return <Link to={`/${_TEST1234.PORTAL_TYPE}/ptl/lbl/osci0111006s/${rowValues.lblId}`}>{value}</Link>;
                return <Link to={`${URLS.osci0111006s}/${rowValues.lblId}`}>{value}</Link>;
            },
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getLblLangList: (page: number = 0) => {
            form.lblLangSrch.handleSubmit(
                () => {
                    grid.lblLangLst.setPage(page);
                    fetch.getLblLangLst.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        deleteLblLang: () => {
            const seltList: any[] = grid.lblLangLst.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            modal.openModal({
                content: "msg.osc.00095",
                onConfirm: () => {
                    const lblIds: string[] = [];
                    seltList.forEach((item) => {
                        lblIds.push(`${item.lblId}`);
                    });
                    fetch.deleteLblLang.fetch(lblIds.join(","));
                },
            });
        },
        click_Grid_LblLangLst: {
            lblId: (data: any) => {
                navigate(`${URLS.osci0111006s}/${data.rowValues.lblId}`);
            },
        },
        onClear: () => {
            form.lblLangSrch.clearValues();
            form.lblLangSrch.setValues({ lblId: "", lblNm: "", bsopClsfCd: "OSC", lblTpCd: "" });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // Service Category 는 고정값이므로 수정할 수 없도록 한다.
        if (comnUtils.isEmpty(form.lblLangSrch.getValue("bsopClsfCd"))) {
            form.lblLangSrch.setValue("bsopClsfCd", "OSC");
        }
        form.lblLangSrch.setEditable("bsopClsfCd", false);

        handler.getLblLangList();
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.lblLangSrch.schema.bsopClsfCd}></Group.Control>
                                <Group.Control {...form.lblLangSrch.schema.lblTpCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLangSrch.schema.lblId}></Group.Control>
                                <Group.Control {...form.lblLangSrch.schema.lblNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        handler.onClear();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getLblLangList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Right>
                            <Button
                                role="delete"
                                onClick={() => {
                                    handler.deleteLblLang();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                    <Group.Section>
                        <Grid {...grid.lblLangLst.grid} data={fetch.getLblLangLst.data?.lblLangList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout.Left>
                <Layout.Button
                    role={"new"}
                    onClick={() => {
                        navigate(URLS.osci0111005s);
                    }}
                ></Layout.Button>
            </Layout.Left>
        </Page>
    );
};
